import { Plug, Inbox, Search, BellRing } from 'lucide-react';
import { useT } from '@/i18n/provider';
import { ProductFlow, type FlowStep } from '@/components/ProductFlow';

/**
 * "Hoe het werkt" in lekentaal: verbinden → verzamelen → analyseren → seintje.
 * Anders dan de feature-page flows (waar stage-namen de app-UI spiegelen)
 * localiseren hier óók de stap-titels: de doelgroep is niet-technisch.
 *
 * Voorlopig alleen op de NL-build gerenderd (gate in App.tsx): de andere
 * locales missen de copy nog en zouden via de i18n-fallback rauwe keys tonen.
 */
export function HowItWorksSection() {
  const t = useT();

  const steps: FlowStep[] = [
    { icon: Plug, title: t('howItWorks.step1.title'), sublabel: t('howItWorks.step1.sub'), accent: 'info' },
    { icon: Inbox, title: t('howItWorks.step2.title'), sublabel: t('howItWorks.step2.sub'), accent: 'primary' },
    { icon: Search, title: t('howItWorks.step3.title'), sublabel: t('howItWorks.step3.sub'), accent: 'cyan' },
    { icon: BellRing, title: t('howItWorks.step4.title'), sublabel: t('howItWorks.step4.sub'), accent: 'warning' },
  ];

  return (
    <section className="py-20 sm:py-28" aria-labelledby="how-it-works-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl animate-on-scroll">
          <p className="eyebrow">{t('howItWorks.eyebrow')}</p>
          <h2
            id="how-it-works-heading"
            className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight text-gray-950 dark:text-white"
          >
            {t('howItWorks.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            {t('howItWorks.subtitle')}
          </p>
        </div>

        <div className="mt-14 animate-on-scroll">
          <ProductFlow steps={steps} />
        </div>
      </div>
    </section>
  );
}
